import { render, staticRenderFns } from "./UiInputWrapper.vue?vue&type=template&id=3fc05b84&scoped=true&"
import script from "./UiInputWrapper.vue?vue&type=script&lang=js&"
export * from "./UiInputWrapper.vue?vue&type=script&lang=js&"
import style0 from "./UiInputWrapper.vue?vue&type=style&index=0&id=3fc05b84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc05b84",
  null
  
)

export default component.exports